export const eventTypes = {
    recommendations: 'RecommendationsClicked',
    advices: 'AdvicesClicked',
    addApplicationBtn: 'AddApplicationBtnClicked',
    addApplicationContinueBtn: 'AddApplicationContinueBtnClicked',
    creator: 'CreatorClicked',
    earnings: 'EarningsClicked',
    lookForJobs: 'lookForJobsClicked',
    archive: 'ArchiveClicked',
    addJobOfferLink: 'AddJobOfferLink',
    pracuj: 'PracujMainClicked',
    theprotocol: 'TheProtocolMainClicked',
    theprotocolRecommendations: 'TheProtocolRecommendationsClicked'
};

export default eventTypes;